/** Currently only listing nextjs routes until we migrate our legacy CRA from react-router to next-router */
export enum AppRoutes {
  loginGuest = '/login-guest/',
  loginHost = '/login-host/',
  signup = '/signup/',
  forgotPassword = '/forgot-password/',
  list = '/list/',
}
